import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { ExportList } from '@/common/entities/export/ExportList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { JobList } from '@/skdr/entities/job/JobList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect } from 'react';
import { InctvRbtLedgerPymtList } from '../inctvRbtLedgerPymt/InctvRbtLedgerPymtList';
import { McdInvLedgerPymtList } from '../mcdInvLedgerPymt/McdInvLedgerPymtList';
import { McoInvLedgerPymtList } from '../mcoInvLedgerPymt/McoInvLedgerPymtList';

export const PymtDetail = () => {
  const { entityObj } = useEntityMgr();

  const rsrc = useRsrc();

  /**
   * This code is not good. Please do not copy this. Particularly, the many if statements are not good,
   * and the insertion of ledgerIds into the entityObj is also not a good pattern.
   *
   * TODO: refactor
   */
  useEffect(() => {
    const domain = entityObj.domain;
    if (domain === undefined) {
      return;
    }

    if (domain === 'MCD') {
      rsrc
        .rows('sc', 'MCD_INV_LEDGER_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((invLedgerPymts) => {
          const ledgerIds = invLedgerPymts.map((invLedgerPymt) => invLedgerPymt.mcdLedgerId);
          entityObj.ledgerIds = ledgerIds;
        });
    } else if (domain === 'CHBK') {
      rsrc
        .rows('sc', 'INDIR_SALE_CHBK_LEDGER_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((saleLedgerPymts) => {
          const ledgerIds = saleLedgerPymts.map((saleLedgerPymt) => saleLedgerPymt.chbkLedgerId);
          entityObj.ledgerIds = ledgerIds;
        });
    } else if (domain === 'MCO') {
      rsrc
        .rows('sc', 'MCO_INV_LEDGER_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((invLedgerPymts) => {
          const ledgerIds = invLedgerPymts.map((invLedgerPymt) => invLedgerPymt.mcoLedgerId);
          entityObj.ledgerIds = ledgerIds;
        });
    } else {
      rsrc
        .rows('sc', 'INCTV_RBT_LEDGER_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((ledgers) => {
          const ledgerIds = ledgers.map((ledger) => ledger.inctvLedgerId);
          entityObj.ledgerIds = ledgerIds;
        });
    }
  }, [entityObj.domain]);

  // Once PymtDetail is refactored into separate components per domain, this will not be necessary
  const secondTab =
    entityObj.domain === 'MCD' ?
      {
        id: 'Invoices and Ledgers',
        label: 'Invoices & Ledgers',
        content: <McdInvLedgerPymtList pymtId={entityObj.id} />,
      }
    : entityObj.domain === 'MCO' ?
      {
        id: 'Invoices and Ledgers',
        label: 'Invoices & Ledgers',
        content: <McoInvLedgerPymtList pymtId={entityObj.id} />,
      }
    : {
        id: 'rbtLedgerPymsts',
        label: 'Rebates and Ledgers',
        content: <InctvRbtLedgerPymtList pymtId={entityObj.id} />,
      }; // TODO: discuss if LedgerList should even exist for the other domains

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    secondTab,
    { id: 'export', label: 'Exports', content: <ExportList parentEntity="PYMT" parentEntityId={entityObj.id} /> },
    {
      id: 'approvals',
      label: 'Approvals',
      disabled: !entityObj.apprJobId,
      content: <JobList chain jobId={entityObj.apprJobId} />,
    },
    {
      id: 'entityProperties',
      label: 'Entity Properties',
      content: <EntityPropList parentEntity="PYMT" parentEntityObj={entityObj} />,
    },
  ];

  let lifecycleActionPluginCode;
  const domain = entityObj.domain;

  if (domain === 'MCD') {
    lifecycleActionPluginCode = 'MCD_PYMT_PROC_MGR_ACTION_PLUGIN';
  } else if (domain === 'CHBK') {
    lifecycleActionPluginCode = 'CHBK_PYMT_PROC_MGR_ACTION_PLUGIN';
  } else if (domain === 'INCTV') {
    lifecycleActionPluginCode = 'INCTV_PYMT_PROC_MGR_ACTION_PLUGIN';
  }

  const lifecycleData = {
    title: 'Payment Lifecycle',
    entity: 'PYMT',
    entityId: entityObj.id,
    pluginCode: lifecycleActionPluginCode,
  };

  const augButtons = (buttons) => {
    buttons.push(<ActionButton data={lifecycleData} toolTip="Run Lifecycle" icon={fas.faPlay} />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
